module.exports = __webpack_public_path__ + "static/grammable-39ccb98e828a34d5a7d2e8e6ce009e5f.png";